module.exports = __webpack_public_path__ + "img/boolean-icon.6e7b7cd4.svg";